export const CUSTOM_HEXS = [
  '#5086F3', '#69D19C', '#6E7794', '#F5D242', '#7F6FF1', '#5EC8F1',
  '#AD53D4', '#F19E55', '#488E89', '#F17C86', '#7DADFF', '#92DEB4', '#949BB3', '#FFF196'
];